import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import { i18n } from './i18n/index.js'

// 导入element
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './styles/global.less'

import windowSizeMixin from '@/mixins/resize'

Vue.mixin(windowSizeMixin)

Vue.use(ElementUI)
Vue.config.productionTip = false

// 防止sessionStorage修改
window.addEventListener('storage', function (e) {
  sessionStorage.setItem(e.key, e.oldValue)
})

const vueInstance = new Vue({
  router,
  i18n,
  store,
  render: (h) => h(App),
}).$mount('#app')

export default vueInstance
